import TextButton from 'LuxKit/Button/TextButton'
import React from 'react'
import Caption from 'LuxKit/Typography/Caption'
import { pluralizeToString } from 'lib/string/pluralize'
import Heading from 'LuxKit/Typography/Heading'
import FormatCurrency from 'components/Common/FormatCurrency'
import { withOfferPageAndReduxState } from 'contexts/OfferPage/withOfferPageState'
import { OfferPageFilterType, takeCurrentOfferState } from 'contexts/OfferPage/offerPageStateReducer'
import {
  getMultiRoomPackagesForFilters, getSelectedOfferPageMultiRoomDay,
} from 'selectors/offerPage/multipleRoomBookingSelectors'
import { getPackagesForFilters, getSelectedOfferPageDay, OfferPackageOptionView } from 'selectors/offerPage/offerPageSelectors'
import ModalFooter from 'LuxKit/Modal/ModalFooter'
import Group from 'components/utils/Group'
import { isMultipleRoomBookingActive } from 'selectors/offerPage/offerPageSharedSelectors'
import { BundleSelectedDaysInfo, getBundleSelectedDays } from 'selectors/offerPage/bundledOfferPageSelectors'

interface Props {
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  className?: string;
  relevantPackages: Array<OfferPackageOptionView>;
  selectedDay?: App.CalendarDay;
  activeFilter?: OfferPageFilterType;
  bundleSelectedDays: BundleSelectedDaysInfo;
}

function OfferFilterSidebarBottomPanel(props: Props) {
  const { onClick, relevantPackages, selectedDay, activeFilter, bundleSelectedDays } = props

  return (
    <ModalFooter>
      <Group
        direction="horizontal"
        horizontalAlign="space-between"
        verticalAlign="end"
      >
        <div>
          <Caption variant="large">
            {pluralizeToString('night', bundleSelectedDays.duration)}{', 2 hotels '}
            {relevantPackages.length !== 1 && ' from'}
          </Caption>
          <Heading as="span" variant="heading5">
            <FormatCurrency value={bundleSelectedDays.hotelTotal} />
          </Heading>{' '}
          <Caption as="span" variant="large">total</Caption>
        </div>
        <div>
          {(activeFilter !== 'checkin' || !!selectedDay) &&
            <TextButton
              kind="primary"
              size="large"
              onClick={onClick}
              type="submit"
            >
              Continue
            </TextButton>}
        </div>
      </Group>
    </ModalFooter>
  )
}

export default withOfferPageAndReduxState((currentState, appState) => {
  const state = takeCurrentOfferState(currentState)
  const isMultiRoom = isMultipleRoomBookingActive(state, appState)

  return {
    bundleSelectedDays: getBundleSelectedDays(appState, currentState),
    relevantPackages: isMultiRoom ? getMultiRoomPackagesForFilters(state, appState) : getPackagesForFilters(appState, state),
    selectedDay: isMultiRoom ? getSelectedOfferPageMultiRoomDay(state, appState) : getSelectedOfferPageDay(appState, state),
  }
}, OfferFilterSidebarBottomPanel)
